import { useTranslations } from "@bsm/component";

export const useMenuItems = () => {
    const [
        ABOUT,
        PARENTS,
        EMMERGENCY_CONTACT,
        PROXY,
        DESIGNATED,
        SCHOOL_ATTENDED,
        EDUCATION_NEEDS_AND_DISABILITIES,
        HEALTH_AND_IMMUNISATION,
        HEALTH_AND_ALLERGIES,

        // PARAMS
    ] = useTranslations(i18nKeys)

    const menuItems = [
        { label: ABOUT, ke: "about", link: "about", startIcon: "fa-solid fa-user" },
        { label: PARENTS, ke: "parents", link: "parents", startIcon: "fa-solid fa-users" },
        { label: EMMERGENCY_CONTACT, ke: "emergencyContact", link: "emergencyContact", startIcon: "fa-solid fa-phone" },
        { label: PROXY, ke: "proxy", link: "proxy", startIcon: "fa-solid fa-user-shield" },
        { label: DESIGNATED, ke: "designationCollectionIndividual", link: "designationCollectionIndividual", startIcon: "fa-solid fa-user-tag" },
        { label: SCHOOL_ATTENDED, ke: "schoolAttended", link: "schoolAttended", startIcon: "fa-solid fa-school" },
        { label: EDUCATION_NEEDS_AND_DISABILITIES, ke: "educationNeedsAndDisabilities", link: "educationNeedsAndDisabilities", startIcon: "fa-solid fa-universal-access" },
        { label: HEALTH_AND_IMMUNISATION, ke: "healthAndImmunisation", link: "healthAndImmunisation", startIcon: "fa-solid fa-syringe" },
        { label: HEALTH_AND_ALLERGIES, ke: "healthAndAllergies", link: "healthAndAllergies", startIcon: "fa-solid fa-heart-pulse" },
        // { label: PARAMS, ke: "params", link: "params", startIcon: "fa-solid fa-gear" },
    ];

    // menuItems.map((item:any) => {
        
    //     item.className = `
    //     relative z-10
    //     bg-blue-500
    //     flex flex-col gap-5
    //     rounded-2xl
    //     shadow-lg shadow-gray-200/50 dark:shadow-black/20
    //     border border-gray-200/50 dark:border-slate-800/50
    //     hover:shadow-xl hover:shadow-gray-200/70 dark:hover:shadow-black/30
    //     `;
    // });
    
    return menuItems;
}

const i18nKeys = [
    "std_about",
    "std_parents",
    "std_emergency_contact",
    "std_proxy",
    "std_designationCollectionIndividual",
    "BSM.Students.ShoolAttended.Title",
    "std_educationNeedsAndDisabilities",
    "std_healthAndImmunisation",
    "std_healthAndAllergies",
    // "std_params"
];
